const BLOCKED_TAGS = /<\/?(?:script|iframe|object|embed|form|link|meta|base|style)\b[^>]*>/gi;
const EVENT_ATTR = /\s+on[a-z]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi;
const JS_URL = /(\s(?:href|src)\s*=\s*)(['"]?)\s*javascript:[^'">\s]*/gi;

/** 연수 본문처럼 저장 HTML을 그릴 때 스크립트와 이벤트 속성을 뺍니다. */
export function sanitizeHtml(html: string): string {
  return html
    .replace(BLOCKED_TAGS, '')
    .replace(EVENT_ATTR, '')
    .replace(JS_URL, '$1$2#');
}
